export default {
  SET_IDS(state, Ids) {
    state.Ids = Ids
  },
  REMOVE_RECORD(state, itemId) {
    const userIndex = state.users.findIndex((u) => u.userID === itemId)

    state.users.splice(userIndex, 1)
  },
  UPDATE_USER(state, data) {
    const userIndex = state.users.findIndex((u) => u.userID === data.user.userID)

    if (data.path != '') state.users[userIndex].avatar = data.path
    // if (data.user.userID == this.$store.state.AppActiveUser) localStorage.setItem('userInfo') = state.users[userIndex]
  },
  APPROVE_Id(state, data) { 
    const IdIndex = state.Ids.findIndex((u) => u._id === data)
    state.Ids[IdIndex].status = 'Approved'
    state.Ids[IdIndex].statusComment = ''
  },  
  REJECT_Id(state, data) { 
    const IdIndex = state.Ids.findIndex((u) => u._id === data.userId)


    state.Ids[IdIndex].status = 'Rejected'
    state.Ids[IdIndex].statusComment = data.reason

  }
}
